import { Component } from '@angular/core';
import { FormBuilder } from '@angular/forms';

import { SubformBaseComponent } from 'src/app/shared/components/subform-base/subform-base.component';

@Component({
  selector: 'app-bitter-properties-subform',
  templateUrl: './bitter-properties-subform.component.html',
  styleUrls: ['./bitter-properties-subform.component.scss'],
})
export class BitterPropertiesSubformComponent extends SubformBaseComponent {
  DICT_PATH = 'PRODUCTS.BITTER_PROPERTIES';

  static buildForm(fb: FormBuilder, _?: object) {
    return fb.group({
      // bitter spirit properties is currently just an object?
    });
  }
}
